import { Link } from 'react-router-dom';
import { categoryShortcuts } from '@/mocks/categories';

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
      {categoryShortcuts.map((cat) => (
        <Link
          key={cat.type}
          to={`/category/${cat.type}`}
          className="group relative flex h-40 items-end overflow-hidden rounded-lg border border-background-200 md:h-44"
        >
          <img
            src={cat.image}
            alt={`${cat.label}频道`}
            title={`${cat.label} - 丝瓜视频`}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
          <div className="relative flex w-full items-center justify-between p-4 md:p-5">
            <div>
              <div className="flex items-center gap-2 text-background-50">
                <i className={`${cat.icon} text-xl`} />
                <span className="font-heading text-lg font-bold">{cat.label}</span>
              </div>
              <p className="mt-0.5 text-xs text-background-100/90">{cat.description}</p>
            </div>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur transition-colors group-hover:bg-accent-500">
              <i className="ri-arrow-right-line text-lg" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}